import { Property } from "csstype";
import { ReactNode, useState } from "react";
import { ChevronUp, ChevronDown } from "lucide-react";

interface PanelProps {
  title: string;
  icon?: ReactNode;
  topRight?: ReactNode;
  children?: ReactNode;
  collapsible?: boolean;
  collapsed?: boolean;
  fullWidth?: boolean;
  minWidth?: Property.MinHeight | undefined;
  bodyMinHeight?: Property.MinHeight | undefined;
}

export default function ViewMgtDevicePanel({
  
  title,
  icon,
  topRight,
  children,
  collapsible,
  collapsed,
  fullWidth,
  minWidth,
  bodyMinHeight,

}: PanelProps) {

  const [isCollapsed, setIsCollapsed] = useState(() => collapsed ?? false);

  return (
    <div
      className={`bg-white rounded-lg border border-gray-200 flex flex-col ${
        fullWidth ? 'w-full' : 'max-w-sm'
      }`}
      style={{ minWidth: minWidth }}
    >
      {/* Header */}
      <div
        className={`border-b flex items-center justify-between px-3 py-2 ${
          collapsible ? 'cursor-pointer' : ''
        }`}
        onClick={() => collapsible && setIsCollapsed(!isCollapsed)}
      >
        <div className="flex items-center gap-2">
          {icon}
          <h2 className="text-lg font-semibold">{title}</h2>
        </div>

        {collapsible && (
          <span className="px-1 py-1">
            {isCollapsed ? <ChevronDown size={20} /> : <ChevronUp size={20} />}
          </span>
        )}

        {!collapsible && topRight && (
          <span className="px-1 py-1">
            {topRight}
          </span>
        )}
      </div>

      {/* Body */}
      <div
        className={`transition-all duration-300 ${
          collapsible && isCollapsed ? 'opacity-0 max-h-0 overflow-hidden' : 'opacity-100 px-3 py-2'
        }`}
        style={{ minHeight: isCollapsed ? undefined : bodyMinHeight }}
      >
        {children}
      </div>
    </div>
  );
}
